module.exports = __webpack_public_path__ + "img/NRU.82e4ee46.svg";